import _ from "lodash";
import { useState } from "react";
import { useRouter } from "next/router";
import World from "../world";
import Gallery from "../types/Gallery";
import { CoHost, MaybeAPIErr } from "../api";

type CoHostHook = {
    onChangeEmail: (e: React.FormEvent<HTMLInputElement>) => void;
    onSubmitAdd: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
    onRemove: (email: string) => Promise<void>;
    err: string;
    isPending: boolean;
    coHosts: Array<CoHost>;
}

function useCoHosts(world: World, gallery: Gallery, initialCoHosts: Array<CoHost>): CoHostHook {
    const [email, setEmail] = useState("");
    const [err, setErr] = useState("");
    const [isPending, setIsPending] = useState(false);
    const [coHosts, setCoHosts] = useState(initialCoHosts);
    const router = useRouter();

    const onChangeEmail = (e: React.FormEvent<HTMLInputElement>) => {
        setEmail(e.currentTarget.value);
    };

    const onSubmitAdd = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setIsPending(true);

        const err = await world.addCoHost(gallery.name, email);

        setIsPending(false);

        if (err) {
            setErr(err.message)
            return;
        }

        setCoHosts(_.concat(coHosts, {email}));
        // router.push("/dashboard/[[...all]]", `/dashboard/galleries/${gallery.id()}`);
    };

    const onRemove = async (email: string): Promise<void> => {
        const err = await world.removeCoHost(gallery.name, email);
        if (err) {
            console.log(err);
            return;
        }
        const nextCoHosts = _.filter(coHosts, (coHost) => {
            return coHost.email !== email;
        });
        setCoHosts(nextCoHosts);
        return;
    }

    return {
        onRemove,
        err,
        isPending,
        onChangeEmail,
        onSubmitAdd,
        coHosts,
    }
};

export default useCoHosts;
